import { redirect } from 'react-router-dom';
import authLoader from './authLoader';

const movementLoader = async () => {
	const { user } = await authLoader();
	if (!user.permissions.isSystemAdmin && !user.permissions.isMovement) {
		throw redirect('/');
	}
	return user;
};

export default movementLoader;
